import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FormatAlignLeftIcon(props: IconProps) {
    return <Icon {...props} iconKey={"format_align_left"}/>
}
